export const COOKIES_MANAGEMENT_COOKIE_NAME = 'cookieManagement';
